import React, {Component, Fragment} from 'react'
import PropTypes from 'prop-types'
import {Radio} from 'antd'

class FilterOptions extends Component {
    state = {
        active: this.props.defaultOption,
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.defaultOption !== this.props.defaultOption) {
            this.setState({
                active: this.props.defaultOption
            })
        }
    }

    _handleChange = e => {
        this._handleUpdateState(e)
    }

    _handleUpdateState = e => {
        const {value} = e.target

        this.setState({
            active: value,
        }, () => {
            const {onChangeOption, field} = this.props

            if (typeof onChangeOption === 'function') {
                onChangeOption(field, value)
            }
        })
    }

    _renderLayoutSelect = () => {
        const {active} = this.state
        const {options, field} = this.props

        return (
            <div>
                <select value={active} className="form-control" name={field}
                        onChange={this._handleUpdateState}>
                    {
                        options.map((option, index) => {
                            if (option.hasOwnProperty('label')) {
                                const {data} = option

                                return (
                                    <Fragment key={index}>
                                        {
                                            data !== undefined && data.map((item, idx) => {
                                                return <option key={idx} value={item.value}>{item.name}</option>
                                            })
                                        }
                                    </Fragment>
                                )
                            }

                            const {name, value} = option

                            return <option key={`${field}_${value}_${index + 1}`} value={value}>{name}</option>
                        })
                    }
                </select>
            </div>
        )
    }

    _renderLayoutLabel = () => {
        const {active} = this.state
        const {options, field} = this.props

        return (
            <div className='btn-group btn-group-toggle'>
                <Radio.Group value={active} onChange={this._handleUpdateState}>
                    {
                        options.map((option, index) => {
                            const {name, value} = option

                            return <Radio.Button key={`${field}_option_${index}`} value={value}>{name}</Radio.Button>
                        })
                    }
                </Radio.Group>
            </div>
        )
    }

    _renderContent = () => {
        const {layout} = this.props

        switch (layout) {
            case 'label':
                return this._renderLayoutLabel()
            case 'select':
                return this._renderLayoutSelect()
            default:
                return ''
        }
    }

    render() {
        const {heading} = this.props
        const content = this._renderContent()

        return (
            <div className='FilterOptions'>
                {
                    heading &&
                    <div className='mb-1 font-weight-bold'>{this.props.heading}</div>
                }

                {content}
            </div>
        )
    }
}

FilterOptions.defaultProps = {
    layout: 'label',
    heading: ''
}

FilterOptions.propTypes = {
    field: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    defaultOption: PropTypes.string.isRequired,
    onChangeOption: PropTypes.func.isRequired,
    layout: PropTypes.oneOf(['select', 'label']).isRequired,
    heading: PropTypes.string,
}

export default FilterOptions
